/** Placeholder for the contact drawer's External contacts tab when nobody has reached out yet. */
import { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'

const EmptyContactsComponent = () => {
  return (
    <div
      css={tw`flex flex-col border border-solid border-[#EDEDED] py-3 bg-white px-4 rounded-2xl`}
    >
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        Nobody has reached out yet.
      </Typography>
    </div>
  )
}

export const EmptyContacts = memo(EmptyContactsComponent)
